import { render, staticRenderFns } from "./overlayHighlight.vue?vue&type=template&id=4b8a51b1&scoped=true&"
import script from "./overlayHighlight.vue?vue&type=script&lang=js&"
export * from "./overlayHighlight.vue?vue&type=script&lang=js&"
import style0 from "./overlayHighlight.vue?vue&type=style&index=0&id=4b8a51b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8a51b1",
  null
  
)

export default component.exports